export default {"src":"https://js-static.iimjobs.com/production/20.1.0/_next/static/media/eye.ef575733.svg","height":8,"width":12,"blurWidth":0,"blurHeight":0};